/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */

import Keyboard from '../keyboard';
import BackgroundRemoval from '../modules/background-removal';

import initEventTracker from './event-tracker';

let tool;
let editor;
let hasRestrictions;

export default async function initializeComponents (t, e) {
  tool = t;
  editor = e;

  const keyboard = new Keyboard(editor);
  keyboard.init();

  editor.gesture = new INKIVE.Gesture(editor.canvas);

  INKIVE.DesignFacade.initialize();
  INKIVE.EditorFacade.initialize(editor.curConfig);
  INKIVE.ProjectFacade.initialize();
  INKIVE.SVGElementLoading.initialize();
  window.AppBridge && AppBridge.initialize();

  hasRestrictions = INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN;
  if (hasRestrictions) {
    await INKIVE.RestrictionsFacade.initialize();
    INKIVE.EditorModeManager.setMode('restrict');
  }

  loadFirstDesign().finally(initializePagesPanel);

  $(window).resize(_.debounce(updateScroll, 300));

  // Hides mobile browser's address bar when page is done loading.
  INKIVE.C.IS_MOBILE && setTimeout(function () { window.scrollTo(0, 1); }, 1);

  BackgroundRemoval.SDK.initialize();
  initEventTracker();
}

function updateScroll () {
  editor.initEditor();
  $('#ruler-vertical, #ruler-horizontal').find('g').empty();
  INKIVE.EditorFacade.handle('zoom', 'fit');
  tool.editor.canvas.runExtensions('browserResize', {});
  tool.resize();
}

function loadFirstDesign () {
  return INKIVE.EditorFacade.handle('page', 'move_to', {
    page_number: INKIVE.page,
    quiet: true
  }).then(function () {
    tool.inkiveLoader(false);
    tool.show();

    const addOn = 'white_label';
    const feature = 'hide_restrictions_overview';
    const disableRestrictions = INKIVE.RestrictionsFacade.hasAddOnAndFeature(addOn, feature);
    const whiteLabelConf = INKIVE.C.WHITE_LABEL_CONFIGURATION || null;
    const tabImages = document.querySelector('#tool-panel .tool-menu [href="#tabImages"]');
    const isTabImagesHidden = tabImages?.parentElement?.style?.display === 'none';

    if (whiteLabelConf && hasRestrictions && disableRestrictions) {
      $('#tool-panel .tool-menu [href="#tabRestricted"]').parent().hide();
      if (isTabImagesHidden) {
        const firstVisibleTab = document.querySelector('#tool-panel .tool-menu li:not(.hide, .hidden, [style*="display: none"]) a');
        if (firstVisibleTab?.offsetParent) {
          // offsetParent property will return null whenever is hidden via the display style property
          firstVisibleTab.click();
        }
      } else {
        tabImages?.click?.();
      }
    } else {
      if (document.querySelectorAll('#svgcontent .main .element').length > 0) {
        if (INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE) {
          INKIVE.RestrictionsFactory.initialize().then(() => {
            const isEnterprise =
              INKIVE.C.WHITE_LABEL_CONFIGURATION.subscription_plan ===
              'enterprise';
            if (isEnterprise) {
              document
                .querySelector(
                  `#tool-panel .tool-menu [href="#tab${
                    INKIVE.Menus.showSimplifiedRestrictions ? 'Simplified' : ''
                  }Restrictions"]`
                )
                .click();
            } else {
              document
                .querySelector('#tool-panel .tool-menu [href="#tabImages"]')
                ?.click();
            }
          });
        } else {
          hasRestrictions && $('#tool-panel .tool-menu [href="#tabRestricted"]').trigger('click');
          !hasRestrictions && $('#tool-panel .tool-menu [href="#tabImages"]').trigger('click');
        }
      } else {
        const tabRestricted = document.querySelector('#tool-panel .tool-menu [href="#tabRestricted"]');
        isTabImagesHidden ? tabRestricted?.click?.() : tabImages?.click?.();
      }
    }

    const isEmpty = $('#svgroot .main').find(':not(title)').length === 0;
    isEmpty && INKIVE.Helpers.isDesygnerProject() && editor.canvas.call('advice.show', 'pick-template');
  });
}

function initializePagesPanel () {
  const PagesPanelView = require('../ui/pages-panel/view');
  window.INKIVE.Menus.pagesPanel = new PagesPanelView({ el: '#pages-panel' });
}
